/**
 * @file Defines the {@link FOOTER_IDS} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * @type {object}
  * @constant
  * @default
  * @property {string} balance - Footer balance ID.
  * @property {string} clock   - Footer clock ID.
  * @property {string} message - Footer message ID.
  * @property {string} name    - Footer game name
  */
 const FOOTER_IDS = {

    balance: 'footer-bottom-balance-amount',
    clock:   'footer-bottom-clock',
    message: 'footer-bottom-message',
    name:    'footer-middle-name',
    win:     'footer-top-win'

 }

 export { FOOTER_IDS }